import React from 'react'
import injectJss from 'react-jss'
import compose from 'recompose/compose'
import classNames from 'classnames'

const style = theme => ({
    slide: {
        height: '100%',
        width: '100%',
        overflow: 'hidden',
    },
})
const Slide = ({ classes, children, className }) => (
    <div className={classNames(classes.slide, className)}>{children}</div>
)

export default compose(injectJss(style))(Slide)
